module.exports = {
  "defaultCurrency": "USD",
  "currencies": [
    {
      "id": 2,
      "code": "USD",
      "name": "$USD",
      "change_store": true,
      "store": "27552890",
      "base_currency": "USD"
    }
  ]
}